// extracted by mini-css-extract-plugin
module.exports = {"deadline":"style-module__deadline___1U37P","active":"style-module__active___dudkY","decision":"style-module__decision___YuXVI"};